export const checkIsOsCompatibleWithTwa = (androidVersion: string) => {
  if (!androidVersion) return false
  const androidVersionStrParts = androidVersion.split('.')
  const sliceOne = Number(androidVersionStrParts[0])
  const sliceTwo =
    androidVersionStrParts[1] && Number(androidVersionStrParts[1])
  const sliceThree =
    androidVersionStrParts[2] && Number(androidVersionStrParts[2])

  return (
    sliceOne > 7 ||
    (sliceOne === 7 && sliceTwo > 1) ||
    (sliceOne === 7 && sliceTwo === 1 && sliceThree > 1)
  )
}

export const checkIsOsCompatibleWithWebView = (androidVersion: string) => {
  return true
}
